import styled from 'styled-components'

export const AvailableSoftwareActionCell = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 5px;
  > div {
    display: flex;
    align-items: center;
  }
`

export const AvailableSoftwareErrorMessage = styled.div`
  & > p {
    margin: 0;
    padding: 0;
    text-align: center;
    word-wrap: break-word;
    white-space: normal;
  }

  padding: 1em;
`

export const AvailableSoftwareWarnings = styled.ul`
  margin: 1em;
  padding: 0;
  text-align: left;
`
